module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_18-ca155b74e1ac75614d0768b69d40af30.png";